// Core Components
let QUEUE_COMPONENT_LIST = {};
import COMPONENT_DATA from './components/data.js';
QUEUE_COMPONENT_LIST.DATA = COMPONENT_DATA;

(async function () {

  const SETTINGS = ('settings' in document.currentScript.dataset?document.currentScript.dataset.settings:{});
  const ALIAS = ('alias' in document.currentScript.dataset?document.currentScript.dataset.alias:'fw_data');
  const LOADER_ALIAS = ('loader_alias' in document.currentScript.dataset?document.currentScript.dataset.loader_alias:'');
  const SUCCESSEVENTNAME = ('successEventName' in document.currentScript.dataset?document.currentScript.dataset.successEventName:false);

  const dataHandler = {
    _hasSetup:false,
    isReady: function()
    {
      if(!('ready' in this))
      {
        this.ready=false;
      }
      return this.ready;
    },
    onReady: function(callback)
    {
      if(typeof callback === 'function')
      {
        this.onReady_callback=callback;
      }
      else
      {
        this._log('error','onReady','Callback not a function',callback);
      }
    },
    init:function(parent){
      this._parent=parent;
      this._hasSetup=false;
      if(!(typeof this._parent === 'object'))
      {
        this._parent={};
      }
      if('_log' in this._parent)
      {
        this._log=function(type,source,message,data='')
        {
          this._parent._log(type,source,message,data,ALIAS);
        };
      }
      else
      {
        this._log = function(type,source,message,data=''){
          console[type](ALIAS+'::'+source+'- '+message,data);
        };
      }
    },
    setup:function()
    {
        try
        {
          if(!this._hasSetup)
          {
            let _this = this;
            _this._hasSetup=true;



            let function__onload = function()
            {
               _this._log('debug','setup','Loading DATA component...');
              try
              {
                let settings = {};
                try
                {
                  _this.settings = JSON.parse(SETTINGS);

                  if(typeof _this.settings === 'object')
                  {
                    settings=_this.settings;
                  }

                }
                catch(ex)
                {
                  // Ok cool
                }
                customElements.define('dsb-data', QUEUE_COMPONENT_LIST['DATA']);

              }
              catch(ex)
              {
                _this._log('error','setup','Loading DATA component failed!',ex);
              }
            };

            if(document.readyState !== 'uninitialized' && document.readyState !== 'loading')
            {
               _this._log('debug','setup','Load event already fired...');
              function__onload();
            }
            else
            {
               _this._log('debug','setup','Waiting for load event...',document.readyState);
              // Everything but IE
              window.addEventListener("load", function() {
              function__onload();
              }, false);
            }
          }
          else
          {
            this._log('warning','setup','Already setup DATA!');
          }
        }
        catch(ex)
        {
          this._log('error','setup','Setup failed!',ex);
        }
    }
  };

  if(typeof window[LOADER_ALIAS] === 'object' && 'registerHandler' in window[LOADER_ALIAS] && typeof window[LOADER_ALIAS].registerHandler === 'function')
  {
    window[LOADER_ALIAS].registerHandler(ALIAS,dataHandler,async function(me,parent){
      me.init(parent);
      me.setup();
    });
  }
  else
  {
    if(!( ALIAS in window ))
    {
      window[ALIAS]=dataHandler;
      window[ALIAS].init();
      window[ALIAS].setup();
    }
    else
    {
      console.debug(LOADER_ALIAS+'/'+ALIAS+':: Looks like window['+ALIAS+'] already exists....skip.');
    }
  }

})();
